import {
  Target,
  Calendar as CalendarIcon,
  ListTodo,
  Building2,
  Users2,
  MessagesSquare,
} from "lucide-react";

export const TABS = [
  { id: "dashboard", label: "Today", icon: Target },
  { id: "tasks", label: "Tasks", icon: ListTodo },
  { id: "clinics", label: "Clinic Pipeline", icon: Building2 },
  { id: "vendors", label: "Vendor Pipeline", icon: Users2 },
  { id: "feedback", label: "Feedback", icon: MessagesSquare },
  { id: "calendar", label: "Calendar", icon: CalendarIcon },
];

export const TASK_CATEGORIES = [
  { id: "clinic_outreach", label: "Clinic Outreach" },
  { id: "vendor_outreach", label: "Vendor Outreach" },
  { id: "product", label: "Product" },
  { id: "feedback", label: "Feedback" },
  { id: "follow_ups", label: "Follow-Ups" },
  { id: "operations", label: "Operations" },
];

export const TASK_STATUSES = [
  { id: "todo", label: "To Do" },
  { id: "in_progress", label: "In Progress" },
  { id: "done", label: "Done" },
];

export const CLINIC_STAGES = [
  "prospect",
  "contacted",
  "discovery_scheduled",
  "demo_completed",
  "pilot_clinic",
  "live",
];

export const VENDOR_STAGES = [
  "prospect",
  "contacted",
  "application_started",
  "submitted",
  "approved",
  "live",
];

export const FEEDBACK_TAGS = [
  "workflow_friction",
  "onboarding",
  "automation",
  "ui_ux",
  "clinic_feedback",
  "vendor_feedback",
];

export const PRIORITY_PILL = {
  high: "bg-rose-50 text-rose-700 border-rose-200",
  medium: "bg-amber-50 text-amber-700 border-amber-200",
  low: "bg-slate-50 text-slate-600 border-slate-200",
};

export const STAGE_LABEL = (s) =>
  (s || "")
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso.slice(0, 10);
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const fmtMRR = (cents) => {
  if (!cents) return "$0";
  const dollars = cents / 100;
  if (dollars >= 1000) return `$${(dollars / 1000).toFixed(1)}k`;
  return `$${dollars.toLocaleString()}`;
};
